// extracted by mini-css-extract-plugin
export default {"error":"ContentBlueprintDropzone_error__HW-h+","message":"ContentBlueprintDropzone_message__CS6fP","dropzone":"ContentBlueprintDropzone_dropzone__9i9PI"};